module.exports = __webpack_public_path__ + "static/media/Chat button small.7b371c28.svg";